import React from 'react'
import { Droppable, Draggable } from 'react-beautiful-dnd'
import { Link } from 'react-router-dom'

import { colors } from '../variables.style'
import { useStyles } from './category-pages.style'
import { REPORT_VIEWERS } from './constants'
import { reportService } from './report.service'

export function CategoryPages ({ group, report, pageNumber, isEditMode = false }) {
  const classes = useStyles()
  const id = group.id
  const pages = group.pages && group.pages.filter((page) => page.viewer !== REPORT_VIEWERS.EXECUTIVE_SUMMARY_PAGE)

  if (isEditMode) {
    return (
      <Droppable droppableId={id}>
        {(provided, snapshot) => (
          <div className={classes.draggableRowContainer} ref={provided.innerRef} style={{ backgroundColor: snapshot.isDraggingOver ? colors.metallicSeaweed : 'transparent' }} {...provided.droppableProps}>
            {pages.map(({ id, title }, index) => (
              <Draggable key={id} draggableId={id} index={index}>
                {(provided) => (<div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                  <div key={id} className={classes.draggableRow}>
                    <div className={classes.grabber}></div>
                    <div className={classes.draggableTitle}>{title}</div>
                  </div>
                </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    )
  } else {
    return (
      <div className={classes.rowContainer} data-qa="report-category-page">
        {pages.map(({ id, title, version }) => {
          pageNumber.current++
          return (
            <div key={id} className={classes.row}>
              <div className={id === report.id ? classes.currentPageNumber : classes.pageNumber}>{pageNumber.current}</div>
              {id === report.id
                ? <div className={classes.currentReport}>{title}</div>
                : (
                  <Link to={reportService.buildPageRoute(report, id, version)} className={classes.pageLink}>
                    {title}
                  </Link>
                )
              }
            </div>
          )
        })}
      </div>
    )
  }
}
